import { enableDevTools } from './enableDevTools';
import { thunk } from './thunk';

export const getDefaultMiddleware = () => {
  let middlewareArray = [thunk];

  if (enableDevTools()) {
    middlewareArray = [
      // eslint-disable-next-line global-require
      require('redux-immutable-state-invariant').default(),
      thunk,
      // eslint-disable-next-line global-require
      require('redux-logger').createLogger({ collapsed: true }),
    ];
  }

  return middlewareArray;
};
